<aside class="sidebar">
  <!-- Categorías -->
  <div class="sidebar__block">
    <h4 class="sidebar__title">{{ copy.sidebarCategories }}</h4>
    <div class="sidebar__pills">
      @for (cat of post().categories; track cat.id) {
        <a
          class="sidebar__pill"
          [routerLink]="['/blog']"
          [queryParams]="{ category: cat.slug }"
        >{{ cat.name }}</a>
      }
    </div>
  </div>

  <!-- Categorías de tienda -->
  @if (storeCategories().length > 0) {
    <div class="sidebar__block">
      <h4 class="sidebar__title">{{ copy.sidebarStoreCategories }}</h4>
      <div class="sidebar__store-categories">
        @for (item of storeCategories(); track item.category.id) {
          <a
            class="sidebar__store-pill"
            [routerLink]="item.link"
          >
            <app-icon [icon]="shoppingBagIcon" [size]="14" />
            {{ item.category.name }}
          </a>
        }
      </div>
    </div>
  }

  <!-- Productos relacionados -->
  @if (relatedProducts().length > 0) {
    <div class="sidebar__block">
      <h4 class="sidebar__title">{{ copy.sidebarRelatedProducts }}</h4>
      <div class="sidebar__products">
        @for (item of relatedProducts(); track item.product.id) {
          <div class="sidebar__product">
            <img
              class="sidebar__product-image"
              [src]="item.product.imageUrl"
              [alt]="item.product.name"
              width="40"
              height="56"
              loading="lazy"
            />
            <div class="sidebar__product-info">
              @if (item.link) {
                <a class="sidebar__product-name sidebar__product-name--link" [routerLink]="item.link">{{
                  item.product.name
                }}</a>
              } @else {
                <span class="sidebar__product-name">{{ item.product.name }}</span>
              }
              @if (item.showPrice) {
                <span
                  class="sidebar__product-price"
                  [style.color]="post().game.accentColor"
                >
                  {{ item.product.price | crc }}
                </span>
              } @else if (item.soldOut) {
                <span class="sidebar__product-sold-out">{{ copy.productSoldOut }}</span>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }

  <!-- Newsletter mini -->
  <div class="sidebar__block sidebar__newsletter">
    <app-newsletter-form
      variant="sidebar"
      inputId="sidebar-newsletter-email"
      [placeholder]="copy.sidebarNewsletterPlaceholder"
      [ctaLabel]="copy.sidebarNewsletterCta"
      [heading]="copy.sidebarNewsletterHeading"
      [description]="copy.sidebarNewsletterDescription"
    />
  </div>
</aside>
